import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { WEB_TYPES } from '../Redux/NavigationRedux'
import I18n from 'i18n-react'

import PropertyTypeContainer from './PropertyTypeContainer'

// components
import TileButton from '../Components/_ui/TileButton.js'

// redux
import DomexActions from '../Redux/DomexRedux'
import GeneralActions from '../Redux/GeneralRedux'
import { SCREENS } from '../Redux/NavigationRedux'

class PropertyContainer extends React.Component {
	static propTypes = {
		domexSetProperty: PropTypes.func.isRequired,
		isMobile: PropTypes.bool.isRequired,
		onSetScreenIsValid: PropTypes.func.isRequired,
		onSetScreenMustBeValid: PropTypes.func.isRequired,
		onSetScreenValidateSig: PropTypes.func.isRequired,
		propertyActive: PropTypes.bool.isRequired,
		screenValidateSig: PropTypes.array.isRequired,
		webType: PropTypes.number.isRequired,
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.screenValidateSig[SCREENS.PROPERTY].validate === true) {
			const valid = this.handleValidate()
			nextProps.onSetScreenIsValid(SCREENS.PROPERTY, valid)
		}
	}

	handleSetProperty = (active) => {
		this.props.domexSetProperty(active)
	}

	handleValidate = () => {
		if (!this.props.isMobile) {
			if (this.props.propertyActive) {
				this.props.onSetScreenValidateSig(SCREENS.PROPERTY_TYPE, true)
				this.props.onSetScreenMustBeValid(SCREENS.PROPERTY_TYPE, true)
			} else {
				this.props.onSetScreenMustBeValid(SCREENS.PROPERTY_TYPE, false)
			}
		}
		return true
	}

	render() {
		return (
			<div>
				{this.props.webType !== WEB_TYPES.DEFAULT &&
				<h3>{I18n.translate('general.whatElse')}</h3>
				}
				<TileButton
					active={this.props.propertyActive}
					id='property'
					label={I18n.translate('general.property')}
					onClick={this.handleSetProperty}
					text={I18n.translate('general.propertyDescription')}
				>
					{!this.props.isMobile && <PropertyTypeContainer/>}
				</TileButton>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	propertyActive: state.domex.propertyActive,
	screenValidateSig: state.general.screenValidateSig,
	isMobile: state.navigation.isMobile,
	webType: state.navigation.webType,
})

const mapDispatchToProps = {
	domexSetProperty: DomexActions.domexSetProperty,
	onSetScreenIsValid: GeneralActions.onSetScreenIsValid,
	onSetScreenValidateSig: GeneralActions.onSetScreenValidateSig,
	onSetScreenMustBeValid: GeneralActions.onSetScreenMustBeValid,
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyContainer)
